import {
  Warning as WarningIcon,
  CheckCircle as CheckIcon,
  Cancel as CancelIcon,
  AccessTime as TimeIcon,
} from '@mui/icons-material';

// Configuración de estados para cuotas
export const INSTALLMENT_STATUS_CONFIG = {
  PENDING: {
    color: 'warning' as const,
    label: 'Pendiente',
    icon: TimeIcon,
  },
  OVERDUE: {
    color: 'error' as const,
    label: 'Vencida',
    icon: WarningIcon,
  },
  PAID: {
    color: 'success' as const,
    label: 'Pagada',
    icon: CheckIcon,
  },
  CANCELLED: {
    color: 'default' as const,
    label: 'Cancelada',
    icon: CancelIcon,
  },
} as const;

// Etiquetas de frecuencia de cuotas
export const INSTALLMENT_FREQUENCY_LABELS = {
  WEEKLY: 'Semanal',
  BIWEEKLY: 'Quincenal',
  MONTHLY: 'Mensual',
} as const;

// Límites de cuotas
export const INSTALLMENT_LIMITS = {
  DEFAULT: 3,
  MIN: 1,
  MAX: 24,
} as const;
